import { CircularProgress, Stack } from '@mui/material';

import styles from './Loader.module.scss';

interface Props {
	show: boolean;
	size?: string;
	className?: string;
	loaderText?: string;
	dataTestId?: string;
}

const { imgbgColor } = styles;

export const Loader = (loaderProps: Props) => {
	const { show, size, className, loaderText, dataTestId } = loaderProps;
	return (
		<div className={className} data-testid={dataTestId}>
			{show && (
				<div className={styles['loader-position']}>
					<Stack>
						<CircularProgress sx={{ color: imgbgColor }} size={size} />
						{loaderText && <h4>{loaderText}</h4>}
					</Stack>
				</div>
			)}
		</div>
	);
};
